import {AfterViewInit, Component, Input} from '@angular/core';
import {SweetAlertService} from 'ngx-sweetalert2';
import {AngularFireAuth} from 'angularfire2/auth';
import {Router} from '@angular/router';
import {UserModel} from '../../pages/user.model';

@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements AfterViewInit {

  @Input('user') user: UserModel;

  constructor(private router: Router, private afAuth: AngularFireAuth, private alertService: SweetAlertService) {

  }

  ngAfterViewInit() {
    (<any>$('#sidebarnav')).metisMenu();
  }

  logout() {
    this.afAuth.auth.signOut()
      .then(a => {
        this.router.navigate(['login']);
      })
      .catch(error => {
        console.error(error);
        this.alertService.error({title: '로그아웃 에러'});
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/shared/sidebar/sidebar.component.ts